import { Router } from 'preact-router';
import { I18nProvider } from '../localization/i18n.context';
import { ThemeProvider } from '../theme/theme.context';

// Code-splitting is automated for `routes` directory
import KnowYourCustomerPage from '../routes/KnowYourCustomerPage/KnowYourCustomerPage';
import StoryBoardPage from '../routes/StoryBoardPage/StoryBoardPage';
import OnboardingSuccessPage from '../routes/OnboardingSuccessPage/OnboardingSuccessPage';
import OnboardingPage from '../routes/OnboardingPage/OnboardingPage';
import PickupPage from '../routes/PickupPage/PickupPage';
import PickupDetailPage from '../routes/PickupPage/Detail/PickupDetailPage';
import PickupListingPage from '../routes/PickupPage/Listing/PickupListingPage';
import { ConfigProvider } from '../config/config.context';
import OnboardingStatusPage from '../routes/OnboardingStatusPage/OnboardingStatusPage';
import TryAgainPage from '../routes/TryAgainPage/TryAgainPage';
import OnboardingErrorPage from '../routes/OnboardingErrorPage/OnboardingErrorPage';
import CardActivationPage from '../routes/CardActivationPage/CardActivationPage';
import CardActivationSuccessPage from '../routes/CardActivationSuccessPage/CardActivationSuccessPage';
import CardActivationErrorPage from '../routes/CardActivationErrorPage/CardActivationErrorPage';
import SetPinPage from '../routes/SetPinPage/SetPinPage';
import CardActivationStatusPage from '../routes/CardActivationStatusPage/CardActivationStatusPage';
import SetPinSuccessPage from '../routes/SetPinStatusPage/SetPinSuccessPage';
import SetPinErrorPage from '../routes/SetPinStatusPage/SetPinErrorPage';
import WalletPage from '../routes/WalletPage/WalletPage';
import CardSettingsPage from '../routes/CardSettingsPage/CardSettingsPage';
import NavigationUtils from '../utils/navigation.utils';
import ResetPinPage from '../routes/ResetPinPage/ResetPinPage';
import ResetPinSuccessPage from '../routes/ResetPinStausPage/ResetPinSuccessPage';
import ReportCardSuccessPage from '../routes/ReportCardStatusPage/ReportCardSuccessPage';
import ReportCardErrorPage from '../routes/ReportCardStatusPage/ReportCardErrorPage';
import ResetPinErrorPage from '../routes/ResetPinStausPage/ResetPinErrorPage';
import SetPinStatusPage from '../routes/SetPinStatusPage/SetPinStatusPage';
import TopupPage from '../routes/TopupPage/TopupPage';
import InstapayInstructionsPage from '../routes/TopupDetailPage/InstapayInstructionsPage';
import FawryInstructionsPage from '../routes/TopupDetailPage/FawryInstructionsPage';
import AtmInstructionsPage from '../routes/TopupDetailPage/AtmInstructionsPage';
import AtmListingPage from '../routes/TopupDetailPage/AtmListingPage/AtmListingPage';
import LuckyHomePage from '../routes/LuckyHomePage/LuckyHomePage';
import AddCardPage from '../routes/AddCardPage/AddCardPage';
import TopupCardListingPage from '../routes/TopupCardListingPage/TopupCardListingPage';
import NoCardsPage from '../routes/NoCardsPage/NoCardsPage';
import InvitationLandingPage from '../routes/InvitationLandingPage/InvitationLandingPage';
import NotificationCenterPage from '../routes/NotificationCenterPage/NotificationCenterPage';
import P2PContactListPage from '../routes/P2PContactListPage/P2PContactListPage';
import P2PContactCardListPage from '../routes/P2PContactCardListPage/P2PContactCardListPage';
import P2PManualPhoneNumberPage from '../routes/P2PManualPhoneNumberPage/P2PManualPhoneNumberPage';
import EducationalOnboardingPage from '../routes/EducationalOnboardingPage/EducationalOnboardingPage';
import EnterAmountPage from '../routes/EnterAmountPage/EnterAmountPage';
import SummaryPage from '../routes/SummaryPage/SummaryPage';
import P2PResultPage from '../routes/P2PResultPage/P2PResultPage';
import CreditOnboardingPage from '../routes/CreditOnboarding/CreditOnboardingPage';
import CompletePage from '../routes/CompletePage/CompletePage';
import OutlineOnboardingScreen from '../routes/OutlineOnboarding/OutlineOnboardingPage';
import InstallmentsPage from '../routes/InstallmentsPage/InstallmentsPage';
import MerchantPage from '../routes/MerchantPage/MerchantPage';
import { OrganizationsProvider } from '../config/organizations.context';

const App = () => (
  <div id="app">
    <ConfigProvider>
      <ThemeProvider>
        <OrganizationsProvider>
          <I18nProvider>
            <Router>
              <LuckyHomePage path={NavigationUtils.Routes.LUCKY_HOME} />
              <StoryBoardPage path="/story-board" />
              <KnowYourCustomerPage path={NavigationUtils.Routes.KYC} />
              <OnboardingPage path={NavigationUtils.Routes.ONBOARDING} />
              <OnboardingStatusPage
                path={`${NavigationUtils.Routes.ONBOARDING_STATUS}/:type`}
              />
              <OnboardingErrorPage
                path={`${NavigationUtils.Routes.ONBOARDING_ERROR}/:type`}
              />
              <OnboardingSuccessPage
                path={`${NavigationUtils.Routes.ONBOARDING_SUCCESS}/:type`}
              />
              <CompletePage
                path={`${NavigationUtils.Routes.COMPLETE}/:style/:type`}
              />
              <CreditOnboardingPage
                path={NavigationUtils.Routes.CREDIT_ONBOARDING}
              />
              <PickupPage path={NavigationUtils.Routes.PICKUP} />
              <PickupDetailPage path={NavigationUtils.Routes.PICKUP_DETAIL} />
              <PickupListingPage path={NavigationUtils.Routes.PICKUP_LISTING} />

              <CardActivationPage
                path={NavigationUtils.Routes.CARD_ACTIVATION}
              />
              <CardActivationSuccessPage
                path={`${NavigationUtils.Routes.CARD_ACTIVATION_STATUS}/success`}
              />
              <CardActivationErrorPage
                path={`${NavigationUtils.Routes.CARD_ACTIVATION_STATUS}/error`}
              />
              <CardActivationStatusPage
                path={`${NavigationUtils.Routes.CARD_ACTIVATION_INFO}/:type`}
              />

              <SetPinPage path={NavigationUtils.Routes.SET_PIN} />
              <SetPinStatusPage
                path={`${NavigationUtils.Routes.SET_PIN_STATUS}`}
              />
              <SetPinSuccessPage
                path={`${NavigationUtils.Routes.SET_PIN_STATUS}/success`}
              />
              <SetPinErrorPage
                path={`${NavigationUtils.Routes.SET_PIN_STATUS}/failure`}
              />

              <WalletPage path={NavigationUtils.Routes.WALLET} />

              <TopupPage path={NavigationUtils.Routes.TOPUP} />
              <InstapayInstructionsPage
                path={`${NavigationUtils.Routes.TOPUP_DETAIL}/instapay`}
              />
              <FawryInstructionsPage
                path={`${NavigationUtils.Routes.TOPUP_DETAIL}/fawry`}
              />
              <AtmInstructionsPage
                path={`${NavigationUtils.Routes.TOPUP_DETAIL}/atm`}
              />
              <AtmListingPage
                path={`${NavigationUtils.Routes.TOPUP_DETAIL}/atm/listing`}
              />

              <CardSettingsPage path={NavigationUtils.Routes.CARD_SETTINGS} />

              <ResetPinPage path={NavigationUtils.Routes.RESET_PIN} />
              <SetPinStatusPage
                path={`${NavigationUtils.Routes.RESET_PIN_STATUS}`}
              />
              <ResetPinSuccessPage
                path={`${NavigationUtils.Routes.RESET_PIN_STATUS}/success`}
              />
              <ResetPinErrorPage
                path={`${NavigationUtils.Routes.RESET_PIN_STATUS}/failure`}
              />

              <ReportCardSuccessPage
                path={`${NavigationUtils.Routes.REPORT_CARD_STATUS}/success`}
              />
              <ReportCardErrorPage
                path={`${NavigationUtils.Routes.REPORT_CARD_STATUS}/error`}
              />

              <AddCardPage path={NavigationUtils.Routes.ADD_CARD} />
              <TopupCardListingPage
                path={NavigationUtils.Routes.TOPUP_CARD_LISTING}
              />

              <NoCardsPage path={NavigationUtils.Routes.NO_CARDS} />
              <TryAgainPage path={NavigationUtils.Routes.TRY_AGAIN} />
              <InvitationLandingPage
                path={NavigationUtils.Routes.LANDING_PAGE}
              />
              <NotificationCenterPage
                path={NavigationUtils.Routes.NOTIFICATION_CENTER}
              />
              <P2PContactListPage
                path={NavigationUtils.Routes.P2P_CONTACT_LIST}
              />
              <P2PContactCardListPage
                path={NavigationUtils.Routes.P2P_CONTACT_CARD_LIST}
              />
              <P2PManualPhoneNumberPage
                path={NavigationUtils.Routes.P2P_MANUAL_PHONE_NUMBER}
              />
              <EducationalOnboardingPage
                path={`${NavigationUtils.Routes.EDUCATIONAL_ONBOARDING}/:type`}
              />
              <EnterAmountPage path={NavigationUtils.Routes.ENTER_AMOUNT} />
              <SummaryPage path={NavigationUtils.Routes.SUMMARY} />
              <P2PResultPage path={NavigationUtils.Routes.P2P_RESULT} />
              <OutlineOnboardingScreen
                path={`${NavigationUtils.Routes.OUTLINE_ONBOARDING}/:type`}
              />
              <InstallmentsPage path={NavigationUtils.Routes.INSTALLMENTS} />
              <MerchantPage path={NavigationUtils.Routes.MERCHANT} />
            </Router>
          </I18nProvider>
        </OrganizationsProvider>
      </ThemeProvider>
    </ConfigProvider>
  </div>
);

export default App;
